import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Atletas = () => {
  const [atleta, setAtleta] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`)
      .then((response) => {
        setAtleta(response.data.data);

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-16">
      {/* <Stats /> */}

      <Link
        to="/admin/atletas/create"
        className="bg-green-600 hover:bg-green-900 py-2 mb-6 px-4 font-medium rounded-lg 
                              shadow-md text-base-100"
      >
        Acicionar
      </Link>
      <div className="overflow-x-auto">
        <table className="table mt-4">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Senha</th>
              <th>E-mail</th>
              <th>Celular</th>
              <th>Perfil</th>
            </tr>
          </thead>

          <tbody>
            {atleta.map((atleta, index) => (
              <tr key={atleta._id} className="bg-base-100 hover:bg-base-300">
                <td className="py-3 px-5">{atleta.nome}</td>
                <td className="py-3 px-5">{atleta.password}</td>
                <td className="py-3 px-5">{atleta.email}</td>
                <td className="py-3 px-5">{atleta.celular}</td>
                <td className="py-3 px-5">{atleta.perfil}</td>
                <td className="py-3 px-5">
                  <div className="flex justify-center gap-x-1">
                    <Link
                      to={`/admin/atletas/edit/${atleta._id}`}
                      className="bg-orange-500 hover:bg-orange-900
                 text-white py-2 px-4 font-medium rounded-l-lg text-sm"
                    >
                      Editar
                    </Link>

                    <Link
                      to={`/admin/atletas/delete/${atleta._id}/${atleta.nome}`}
                      className="bg-red-500 hover:bg-red-900
                 text-white py-2 px-4 font-medium rounded-r-lg text-sm"
                    >
                      Remover
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

//!

export default Atletas;
